import http from 'hub-http/clients/apiClient';
let apiClient = http;
export function getApiClient() {
  return apiClient;
}
export function setApiClient(_apiClient) {
  apiClient = _apiClient;
}